var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
        },
        [
          _c("h1", { staticClass: "h2" }, [
            _vm._v("\n      Notas fiscais -\n      "),
            this.viewData.user
              ? _c("span", [_vm._v(_vm._s(this.viewData.user.name))])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-toolbar mb-2 mb-md-0" },
            [
              _c(
                "div",
                { staticClass: "btn-group mr-2" },
                [
                  _c(
                    "BaseButtonComponent",
                    {
                      attrs: { variant: "primary-action" },
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.show("bv-modal-example")
                        }
                      }
                    },
                    [_vm._v("Enviar Nota Fiscal")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: { id: "bv-modal-example" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function() {
                        return [_vm._v("Nova Nota Fiscal")]
                      },
                      proxy: true
                    },
                    {
                      key: "modal-footer",
                      fn: function() {
                        return [
                          _c(
                            "BaseButtonComponent",
                            {
                              staticStyle: { float: "left" },
                              attrs: { variant: "secondary-action" },
                              on: {
                                click: function($event) {
                                  return _vm.$bvModal.hide("bv-modal-example")
                                }
                              }
                            },
                            [_vm._v("Fechar")]
                          ),
                          _vm._v(" "),
                          !_vm.viewData.loadingDoc
                            ? _c(
                                "BaseButtonComponent",
                                {
                                  staticStyle: { float: "right" },
                                  attrs: {
                                    variant: "primary-action",
                                    disabled:
                                      !_vm.state.url ||
                                      !_vm.state.description ||
                                      _vm.viewData.saving
                                  },
                                  on: { click: _vm.save }
                                },
                                [
                                  _vm.viewData.saving
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: "three-dots",
                                          animation: "cylon"
                                        }
                                      })
                                    : _c("span", [
                                        _vm._v("Criar e Enviar Email")
                                      ])
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-form",
                    [
                      _c("error-container", {
                        attrs: { errors: _vm.viewData.errors || [] }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "input-group-1",
                            label: "Descrição",
                            "label-for": "input-1"
                          }
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              required: "",
                              placeholder: "Informe a descrição",
                              state: _vm.isOk("description"),
                              rows: "3",
                              "max-rows": "6"
                            },
                            model: {
                              value: _vm.state.description,
                              callback: function($$v) {
                                _vm.$set(_vm.state, "description", $$v)
                              },
                              expression: "state.description"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-form-invalid-feedback", [
                            _vm._v(_vm._s(_vm.getError("description")))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("image-upload", {
                        attrs: {
                          currentUrl: this.state.photoUrl,
                          updateUrl: _vm.updateUrl,
                          setLoading: _vm.setLoadingPhoto,
                          label: "Arquivo: ",
                          extensions: "pdf",
                          accept: "application/pdf",
                          isDoc: true
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      this.viewData.user
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("b-breadcrumb", {
                    attrs: {
                      items: [
                        {
                          text: "Lista de Usuários",
                          href: "/#/" + this.viewData.profile + "s"
                        },
                        {
                          text: "Notas Fiscais",
                          href: "#",
                          active: true
                        }
                      ]
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.viewData.loading
        ? _c("loading-list")
        : !_vm.viewData.loading && _vm.state.list && _vm.state.list.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "table-responsive d-flex justify-content-between flex-column h-100"
            },
            [
              _c(
                "table",
                { staticClass: "table b-table table-hover table-bordered" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("td", [_vm._v("Data de Envio")]),
                      _vm._v(" "),
                      _c("td", [_vm._v("Nota")]),
                      _vm._v(" "),
                      _c("td")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.state.list, function(item) {
                      return _c("tr", { key: item.id }, [
                        _c("td", [
                          _vm._v(_vm._s(_vm.formatDate(item.createdAt)))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "a",
                            { attrs: { href: item.url, target: "_blank" } },
                            [
                              _vm._v(
                                _vm._s(
                                  item.description.length > 100
                                    ? `${item.description.substring(
                                        0,
                                        100
                                      )} ...`
                                    : item.description
                                )
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "BaseButtonComponent",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                attrs: {
                                  size: "sm",
                                  title: "Enviar Email",
                                  variant: "secondary-action"
                                },
                                on: { click: () => _vm.send(item) }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "envelope",
                                    "aria-hidden": "true"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "BaseButtonComponent",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                attrs: {
                                  size: "sm",
                                  title: "Excluir",
                                  variant: "danger"
                                },
                                on: { click: () => _vm.remove(item) }
                              },
                              [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "trash",
                                    "aria-hidden": "true"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c("b-pagination-nav", {
                attrs: {
                  "link-gen": _vm.linkGen,
                  "number-of-pages": _vm.state.pageCount,
                  "use-router": ""
                }
              })
            ],
            1
          )
        : !_vm.viewData.loading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }